import React, { Component } from 'react';
import "tabler-react/dist/Tabler.css";
import { Site, Dimmer } from "tabler-react";
import { Router, Route, Switch } from "react-router-dom";
import NotFound from "./NotFound";
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import history from './historialRuta';
import AuthPage from "./auth/Auth"
import LoginPage from "./auth/Login"
import Logout from "./auth/Logout";
import Home from "./Home";
import axios from "axios";
import { getAPISMaster } from './functions/getLambdasEndpoints';
import Inicio from "./Inicio";

Amplify.configure(awsconfig);

/**
 * Clase App que funciona como Ruteador valida que el usuario esté logueado para dar acceso al sistema
 * @author Joel Martinez <joel.martinez@mxmart.mx>
 * @version 1.0 09/07/2021
 */
class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loggedIn: false,
			cargando: true,
			history: this.props.history ? this.props.history : history,
			profile: false
		}
	}

	componentDidMount = async () => {
		try {
			if (localStorage.getItem("access_token") !== null) {
				const userInfo = JSON.parse(localStorage.getItem('profile'));
				const apiAuthValidaToken = await axios.get(getAPISMaster().apis.apiAuth.endpoint, {params: {access_token: localStorage.getItem('access_token'), usuario: userInfo.username}});
				if (apiAuthValidaToken.status === 200) {
					if (apiAuthValidaToken.data.status) {
						this.setState({loggedIn: true, cargando: false, profile: userInfo});
					} else {
						this.setState({cargando: false});
					}
				} else {
					this.setState({cargando: false});
				}
			} else {
				this.setState({cargando: false});
			}
		} catch (error) {
			console.log(error)
		}
	}

	render() {
		if (this.state.cargando === true ) {
			return (
				<Site>
					<Dimmer loader active />
				</Site>
			)
		}
		if (this.state.loggedIn) {
			return (
				<Router history={this.state.history}>
					<Switch>
						<Route exact path="/" render={() => <Inicio ruta="/" profile={this.state.profile} />} />
						<Route exact path="/mis-cursos" render={() => <Inicio ruta="mis-cursos" profile={this.state.profile} />} />
						<Route exact path="/actividades" render={() => <Inicio ruta="actividades" profile={this.state.profile} />} />
						<Route exact path="/perfil-del-alumno" render={() => <Inicio ruta="perfil-del-alumno" profile={this.state.profile} />} />
						<Route exact path="/riesgo-del-alumno" render={() => <Inicio ruta="riesgo-del-alumno" profile={this.state.profile} />} />
						<Route exact path="/ingresar-a-plataformas" render={() => <Inicio ruta="ingresar-a-plataformas" profile={this.state.profile} />} />
						<Route component={Logout} exact path="/logout"/>
						<Route component={NotFound} />
					</Switch>
				</Router>
			);
		} else {
			return (
				<Router history={this.state.history}>
					<Switch>
						<Route component={LoginPage} exact path="/login"/>
						<Route component={AuthPage} path="/auth"/>
						<Route component={Home} />
					</Switch>
				</Router>
			);
		}
	}
}

export default App;
